'use client';

import {Box} from '@dagster-io/ui-components';

import styles from '@/app/signup/SignupPage.module.css';
import CreateYourAccount from '@/components/CreateYourAccount';
import DagsterPlusLogo from '@/components/DagsterPlusLogo';
import {BodyText} from '@/components/Text';
import ThemedPage from '@/components/ThemedPage';
import {TryDagsterForFree} from '@/components/TryDagsterForFree';

export default function SignupPage() {
  return (
    <ThemedPage>
      <div className={styles.viewportContainer}>
        <div className={styles.gridContainer}>
          <div className={styles.signUpGrid}>
            <div className={styles.leftColumn}>
              <TryDagsterForFree />
            </div>
            <Box
              className={styles.rightColumn}
              flex={{direction: 'column', justifyContent: 'center', alignItems: 'center', gap: 16}}
            >
              <div className={styles.dagsterPlusLogo}>
                <DagsterPlusLogo />
              </div>
              <CreateYourAccount />
              <BodyText>
                Already have an account? <a href="/login">Sign in</a>
              </BodyText>
              <BodyText>
                Would you rather talk to our sales team?{' '}
                <a href="https://dagster.io/request-a-demo">Book a demo</a>
              </BodyText>
            </Box>
          </div>
        </div>
      </div>
    </ThemedPage>
  );
}
